import React, { useContext, useEffect, useState } from "react";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { context } from "../context/context";
import TravelSuggestionCommentsTable from "../components/TravelSuggestion/TravelCommentsTable";

const TravelSuggestionComments = () => {
    // state
    const [comments, setComments] = useState([]);
    const [title, setTitle] = useState();
    const [loading, setLoading] = useState(false);
    // context
    const { selectedTravelId } = useContext(context);
    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Travel/${selectedTravelId}`)
            .then((res) => {
                setLoading(false);
                setTitle(res.data.result.title);
                setComments(res.data.result.comments);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [selectedTravelId]);

    return (
        <>
            <h3>کامنت های {title}</h3>
            <TravelSuggestionCommentsTable
                comments={comments}
                loading={loading}
            />
        </>
    );
};

export default TravelSuggestionComments;
